import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faLeaf, faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-cookies-consent',
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  templateUrl: './cookies-consent.component.html',
  styleUrls: ['./cookies-consent.component.scss']
})
export class CookiesConsentComponent implements OnInit {
  faTimes = faTimes;
  showCookiesConsentBar = false;
  constructor() {
    this.showCookiesConsentBar = JSON.parse(localStorage.getItem('showedCookiesConsentBar') ?? "false") ?? false;
  }

  ngOnInit(): void {
  }

  closeCookiesConsent(cookiesAllowed: boolean) {
    localStorage.setItem('cookiesAllowed', JSON.stringify(cookiesAllowed));
    localStorage.setItem('showedCookiesConsentBar', JSON.stringify(true));
    this.showCookiesConsentBar = true;
  }
}
